import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Check } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { IMAGES } from "@/lib/site";

const POINTS = ["Up to 1 Gbps", "Ultra-low latency", "Fiber-like, no trenching"];

export default function WavTeaser() {
  return (
    <section className="relative py-24 sm:py-32 bg-ink-950 overflow-hidden" data-testid="wav-teaser">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <Reveal>
          <div className="relative">
            <div className="absolute -inset-4 bg-cyan-500/10 blur-3xl rounded-full" />
            <motion.div
              initial={{ clipPath: "inset(0 100% 0 0)" }}
              whileInView={{ clipPath: "inset(0 0% 0 0)" }}
              viewport={{ once: true }}
              transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
              className="relative rounded-2xl overflow-hidden border border-white/10"
            >
              <img src={IMAGES.fiberCyan} alt="Glowing cyan fiber optic strands" className="w-full h-[440px] object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-ink-950/70 to-transparent" />
              <div className="absolute bottom-5 left-5 font-mono-tech text-xs text-cyan-400 uppercase tracking-widest">// WAVFiber</div>
            </motion.div>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <p className="overline mb-4">Introducing WAVFiber</p>
          <h2 className="font-display font-extrabold text-4xl sm:text-5xl tracking-tighter text-white leading-[0.95]">
            Fiber speeds.<br />Zero cables.
          </h2>
          <p className="mt-6 text-lg text-zinc-400 leading-relaxed">
            The next generation of wireless internet — delivering fiber-like performance up to 1 Gbps without the hassle of trenching or long installs. Available now in select locations.
          </p>
          <ul className="mt-8 space-y-3">
            {POINTS.map((p) => (
              <li key={p} className="flex items-center gap-3 text-white">
                <span className="w-6 h-6 grid place-items-center rounded-full bg-cyan-500/15 text-cyan-400"><Check size={14} /></span>
                {p}
              </li>
            ))}
          </ul>
          <Link to="/wavfiber" className="mt-10 inline-flex items-center gap-2 text-cyan-400 font-display font-bold uppercase tracking-widest text-sm hover:gap-3 transition-all" data-testid="wav-learn-more">
            Explore WAVFiber <ArrowRight size={18} />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
